import {useContext, useEffect} from "react";
import {ClientBridge} from "../index";
import {useAsync} from "react-async";
import {unCapitalizeFirstLetter} from "../aodApi/aodUtils";
import {includes, merge, omitBy, isUndefined} from 'lodash';
import {useModelSet} from "../model/modelHooks";


// These are the actual table alias used in the AOD query builder
// todo order/campaign ?other
const tableMap = {
    'salesSheet': 'ss',
    'specAd': 'sa',
    'account': 'a',
    'advertiser': 'ad',
    'company': 'c',
    'salesRep': 'sr'
}

const updatedList = ['salesSheet','specAd', 'project', 'projectItem'] ;  // also  Miad Doc

export const aodSearch = async ({aodService, itemType, query={}, view}) => {
    const
    {
        //required
        searchBy,
        id,
        // optional
        sortObj,  // default to searchBy
        //sortField = 'updatedDate', // sort order default to most recently used itemType
        ascending = false,
        filterField,
        filterObj,
        fieldValue,
        comparisonType = 'EQUALS',
        pageSize,
        firstRow
    } = query;
    let {sortField = 'modifiedDate'} = query;

    if ( ! (itemType && searchBy && id)) {
        //todo ?error or empty?
        return {records:[], total:0};
    }

    const callName = unCapitalizeFirstLetter(itemType);
    const itemCall = aodService.itemCalls[callName];

    if (sortField=== 'updatedDate' && ! includes(updatedList, itemType)) {
        sortField = 'modifiedDate';
    } else if (sortField=== 'modifiedDate' && includes(updatedList, itemType)) {
        sortField = 'updatedDate';
    }
    let params = {
        sortColumn: tableMap[sortObj || itemType] + '.' + sortField,
        ascending,
        view,
        pageSize, firstRow
    }

    // todo FUDGE - server is treating firstRow like offset
    if (params.firstRow) {
        params.firstRow--;
    }

    // todo check and add as group - later could be array
    if (filterField) {
        merge(params, {
            fieldValue,
            comparisonType,
            fieldName: tableMap[filterObj || itemType] + '.' + filterField
        });
    }
    params = omitBy(params, isUndefined); // clean up for MCC libs

    const result = await itemCall.search(id, searchBy, params);
    // todo ?trap error response
    const records = itemCall.getRecords(result);

    return {records, total: result.totalSize};  //pagecount & size?
}

export async function searchAndSave({model, setName, ...args}){
    const {itemType, query} = args;
    const {searchBy,id} = query;
    const result = await aodSearch(args);
    if ( setName && itemType && searchBy && id && result) {
        model[itemType].replace(setName, result.records || []);
    }
    return result;
}

const watchFn = ({query}, {query:lastQuery})=>{  // (currentProps, previousProps))
    //todo ?use deep compare to detect real diffs.
    return true;
}



//todo ?allow unamed set
// - ? itemType can change in query - would break
// NOTE: does selective model update to catch item updates/edits - real potential for recursion
export function useAodSearch(query,itemType,setName){

    const {aodService, model} = useContext(ClientBridge);
    const [modelData,,, diff ]= useModelSet(itemType, setName);

    const asyncResult = useAsync({
        promiseFn: searchAndSave, //aodSearch,
        intialValue:{},
        watch: query,   //watchFn: watchFn,
        aodService,
        model,
        query,
        itemType,
        setName
    });

    const {data, setData} = asyncResult;

    useEffect(()=>{
        if (diff  && !diff.isReplaced()) {
            console.log('diff :' + diff.isReplaced());
            data.records = modelData  // but leave total intact
            setData(data) //Todo don't re-trigger this effect by using existion data object? (still fires twice)
        }
    },[modelData, diff, setData, data]);




    return asyncResult;
}

